function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { firebase } from './../../utils/firebase/firebase';

import * as chatroomActions from './chatroomActions';

import MessageForm from './MessageForm/MessageForm';
import MessagesList from './MessagesList/MessagesList';
import Preview from './Preview/Preview';
import ReportModal from './ReportModal/ReportModal';

export var Chatroom = function (_Component) {
    _inherits(Chatroom, _Component);

    function Chatroom() {
        _classCallCheck(this, Chatroom);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Chatroom.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        var _props = this.props,
            chatroomId = _props.chatroomId,
            dispatch = _props.dispatch;


        firebase.firebaseApp.database().ref('rooms/' + chatroomId).once('value').then(function (snapshot) {
            var metaData = snapshot.val() && snapshot.val().metaData || '';
            dispatch(chatroomActions.getChatroomMetaData(metaData));
        });

        firebase.firebaseApp.database().ref('rooms/' + chatroomId + '/users').on('child_added', function (snapshot) {
            var uid = snapshot.val();
            _this2.props.dispatch(chatroomActions.retrieveUser(uid));
        });
    };

    Chatroom.prototype.componentWillUnmount = function componentWillUnmount() {
        var chatroomId = this.props.chatroomId;

        firebase.firebaseApp.database().ref('rooms/' + chatroomId + '/users').off();
    };

    Chatroom.prototype.render = function render() {
        var showPreview = this.props.showPreview;


        return React.createElement(
            'div',
            { className: 'chatroom' },
            function () {
                if (showPreview) {
                    return React.createElement(Preview, null);
                } else {
                    return React.createElement(
                        'div',
                        { className: 'chatroom-container' },
                        React.createElement(ReportModal, null),
                        React.createElement(MessagesList, null),
                        React.createElement(MessageForm, null)
                    );
                }
            }()
        );
    };

    return Chatroom;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        chatroomId: state.chatroom.chatroomId,
        showPreview: state.chatroom.showPreview
    };
};

export default connect(mapStateToProps)(Chatroom);


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Chatroom/Chatroom.js
// module id = 220
// module chunks = 0